import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TCategory, TGoal, TInterest, TLifestyleCategory } from "../../types";

type DictState = {
    goals: TGoal[],
    interests: TInterest[],
    categories: TCategory[],
    lifestyleCategories: TLifestyleCategory[]
};

const initialState: DictState = {
    goals: [],
    interests: [],
    categories: [],
    lifestyleCategories: []
};

const dictSlice = createSlice({
    name: "dict",
    initialState,
    reducers: {
        setGoals(state, action: PayloadAction<any>) {
            state.goals = action.payload;
        },
        setInterests(state, action: PayloadAction<any>) {
            state.interests = action.payload;
        },
        setCategories(state, action: PayloadAction<any>) {
            state.categories = action.payload;
        },
        setLifestyleCategories(state, action: PayloadAction<any>) {
            state.lifestyleCategories = action.payload;
        },
    },
});

export const { setGoals, setInterests, setCategories, setLifestyleCategories } = dictSlice.actions;
export default dictSlice.reducer;
